import UAParser from "my-ua-parser";

export const isRunningOnClient = (): boolean => typeof window !== "undefined";

export const isIOS = (): boolean =>
  isRunningOnClient() &&
  /iPad|iPhone|iPod/.test(navigator.userAgent) &&
  !(window as { MSStream?: unknown }).MSStream;

export const isSafari = (): boolean =>
  isRunningOnClient() &&
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const isIOSSafari = (): boolean => isIOS() && isSafari();

export const isSamsungBrowser = (): boolean =>
  isRunningOnClient() && /SamsungBrowser/i.test(navigator.userAgent);

export const isMobile = (): boolean => {
  if (typeof window === "undefined") return false;
  const parser = new UAParser(navigator.userAgent);
  const ua = parser.getDevice();
  return ua.type === "mobile";
};

export const isFacebookBrowser = (): boolean => {
  if (!isRunningOnClient()) return false;
  const parser = new UAParser(navigator.userAgent);
  const browser = parser.getBrowser();
  return browser.name === "Facebook";
};
